import { IFormValues } from '../../popups/MedicalNoteModal/form/types';
import { ICarePlanMedicalNote } from '~/services/api/carePlanMedicalNotes/types';

const getEditValues = (medicalNote: ICarePlanMedicalNote): IFormValues => {
  const date = new Date(medicalNote.date);

  return {
    reason: medicalNote.reason,
    date: new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()).toISOString(),
  };
};

export default getEditValues;
